import PurchaseOrders from 'types/entities/PurchaseOrders';

export interface PurchaseOrderState {
  datas: PurchaseOrders[] | null;
  poref: string;
  postart: string;
  poend: string;
  poservice: number;
  specref_ws: number;
  referencechrono_offreref: number;
  is_archived: number;
  is_valid: number;
}

export const purchaseOrderState: PurchaseOrderState = {
  datas: [],
  poref: '',
  postart: '2023-10-12T00:00:00.000Z',
  poend: '2023-10-31T00:00:00.000Z',
  poservice: 0,
  specref_ws: 0,
  referencechrono_offreref: 0,
  is_archived: 0,
  is_valid: 0,
};